var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"tool"}},[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"icon-ios":"f7:chevron_left","icon-md":"material:chevron_left","href":"/listcreditrequest/"}},[_vm._v("Back")])],1),_vm._v(" "),_c('f7-nav-title',[_vm._v(" Add Credit Request ")]),_vm._v(" "),_c('f7-nav-right')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }